import { UserPermissions, PermissionStatus } from '@backrs_ui/common-ui';

export const UI_PERMISSIONS = {
  ACCESS_SUPER_COACH: 'access_super_coach',
  ACCESS_SUPER_USER: 'access_super_user',
} as const;

type UIPermission = (typeof UI_PERMISSIONS)[keyof typeof UI_PERMISSIONS];

export type UIPermissionList = Record<UIPermission, PermissionStatus>;

export const userPermissionsTransformer = ({ permissions }: UserPermissions): UIPermissionList => ({
  [UI_PERMISSIONS.ACCESS_SUPER_COACH]: permissions?.access_super_coach || {
    allowed: false,
  },
  [UI_PERMISSIONS.ACCESS_SUPER_USER]: permissions?.access_super_user || {
    allowed: false,
  },
});
